import config from 'constants/config'
import { LUXURY_ESCAPES } from 'constants/brands'

export const isMaldivesCharterRegionEnabled = (state: App.State) => {
  const regionCode = state.geo.currentRegionCode
  return regionCode === 'AU' || (config.agentHub.isEnabled && regionCode === 'NZ')
}

export const isMaldivesCharterCarouselEnabled = (state: App.State) => (
  isMaldivesCharterRegionEnabled(state) && config.BRAND === LUXURY_ESCAPES
)
